import { render } from "./edit.vue?vue&type=template&id=54b294a6"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=54b294a6&lang=less"
script.render = render

export default script